module.exports = __webpack_public_path__ + "static/bg-sec10-sm-ed64a326a315ca1affad8791ce5297fc.jpg";